import {
  Box,
  Card,
  ContentBlock,
  Heading,
  Stack,
  Strong,
  Text,
} from 'braid-design-system';
import React from 'react';

const RenewListingSuccess = () => (
  <Box background="brandAccent" paddingTop="xxlarge" paddingBottom="large">
    <ContentBlock>
      <Stack space="xlarge">
        <Heading align="center" weight="weak" level="1">
          Thanks, we&apos;ll be in touch soon
        </Heading>
        <Card rounded>
          <Box padding="large">
            <Stack space="large">
              <Text>
                <Strong>Renewal: Business Listing</Strong>
              </Text>
              <Text>
                Thanks for getting in touch about renewing your business
                listing. A member of our team will be in touch shortly to
                organise payment and activate your ad.
              </Text>
              <Text>Thanks and speak soon,</Text>
              <Text>
                <Strong>The SEEK Business team</Strong>
              </Text>
            </Stack>
          </Box>
        </Card>
      </Stack>
    </ContentBlock>
  </Box>
);

export default RenewListingSuccess;
